<template>
<div v-if="!displayProjectList || selectedProject > 0">
    <div 
      v-for="group in groupedProjects" 
      :key="group.referential_id" 
      class="referential-group"
      >
      <div>
          <div 
              v-for="project in group.projects" 
              :key="project.project_id" 
              class="project-item"
          >
              <div class="title-col" :title="project.title">{{ project.title }}</div>
              <div class="description-col" :title="project.description">{{ project.description }}</div>
              <div class="actions-col" v-if="selectedProject > 0">
                  <button 
                    v-if="project.PC && project.status == 'EDITING'"
                    @click.stop="editProject(project)" 
                    title="Editer le projet" 
                    class="btn btn-icon"
                    ><i class="bi bi-pencil-fill"></i></button>
                  <button 
                    v-if="(isAdmin || project.PC) && !project.has_evaluator && project.status === 'ARCHIVE'"
                    @click.stop="deleteProject(project.project_id)" 
                    title="Supprimer le projet" 
                    class="btn btn-icon"
                    ><i class="bi bi-trash3-fill"></i></button>
                  <button 
                    v-if="(project.PC|| isAdmin ) && !project.has_evaluator && project.status !== 'ARCHIVE' && project.status !== 'VALIDATION' && project.status !== 'VALIDATED'"
                    @click.stop="changeProjectStatus('ARCHIVE')" 
                    title="Archiver le projet" 
                    class="btn btn-icon"
                    ><i class="bi bi-trash3-fill"></i></button>
                    <button 
                    v-if="project.PC && project.status === 'ARCHIVE' && !project.has_evaluator"
                    @click.stop="changeProjectStatus('EDITING')" 
                    title="Restaurer projet" 
                    class="btn btn-icon"
                    ><i class="bi bi-rewind"></i></button>
                  <button 
                    @click.stop="duplicateProject(project.project_id)" 
                    title="Dupliquer le projet" 
                    class="btn btn-icon"
                    ><i class="bi bi-copy"></i></button>
                  <!-- <button 
                    v-if="false"
                    @click.stop="variantProject(project.project_id)" 
                    title="Créer une variante" 
                    class="btn btn-icon"
                    ><i class="bi bi-diagram-2-fill"></i></button> -->
                    <button v-if="(project.PE && project.status == 'VALIDATION') || project.status != 'VALIDATION'" @click.stop="openPDF(project)"
                     class="btn btn-icon"
                     ><i class="bi bi-filetype-pdf" title="Génération de pdf"></i></button>
                    <button
                     @click.stop="analyzeProject()"
                     class="btn btn-icon"
                     ><i class="bi bi-exclamation-circle" title="Analyse du projet"></i></button>
                  <div v-if="selectedProject > 0" class="action-buttons">
                    <button v-if="project.status === 'EDITING' && selectedProject > 0 && project.PC" @click.stop.prevent="changeProjectStatus('VALIDATION')" class="create-button green-button">Mise en évaluation</button>
                    <button v-if="project.status === 'VALIDATION' && selectedProject > 0 && project.PE" @click.stop.prevent="changeProjectStatus('EDITING')" class="create-button">Remise en édition</button>
                    <button v-if="project.status === 'VALIDATION' && selectedProject > 0 && project.PE" @click.stop.prevent="changeProjectStatus('VALIDATED')" class="create-button green-button">Valider projet</button>
                    <button v-if="selectedProject > 0" @click="resetProject" class="back-button">Retour</button>
                    <!-- <button v-if="selectedProject > 0" @click.stop.prevent="changeProjectStatus('ARCHIVE')" class="create-button">Archiver</button> -->
                </div>
                  <ProjectModalCreator v-if="canEditList.projectModalOpen" />
                  <ConfirmationDialog v-if="canEditList.confirmationDialogOpen" />
                  <LoadingOverlay v-if="loading"/>
              </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import '../../assets/styles/base.css'
import ProjectModalCreator from '../project/ProjectModalCreator.vue'
import ConfirmationDialog from './ConfirmationDialog.vue'
import LoadingOverlay from './LoadingOverlay.vue';

export default {
  name: "ProjectHeader",
    components :{
        ProjectModalCreator,
        ConfirmationDialog,
        LoadingOverlay
        },
  props: {
      displayProjectList: {
        type: Boolean,
        default: true
      }
  },
  data() {
      return {
          filters: {
              title: "",
              status: ""
          },
          statusOptions: [
          { value: '', label: 'Status' },
          { value: 'EDITING', label: 'Edition' },
          { value: 'VALIDATION', label: 'En validation' },
          { value: 'VALIDATED', label: 'Validé' },
          { value: 'ARCHIVE', label: 'Archivé' }
        ],
          showArchived: false,
          isGeneratingPDF:false,
          fetchedAnswersOnce:false,
       }
  },
  computed: {
      ...mapState("project", ["projectData", "selectedProject", "canEditList", "loading", "questionTree", "referential_id", "answerQ", "answerQTest", "evaluationCriteriaColor", "sharecode", "filterBlackQuestionsActive", "files", "roles", "projectErrors", "tempPdf"]),
      ...mapState("auth", ["user_id", "isAdmin"]),
      ...mapState("referential", ["selectedReferential", "referentialData"]),
      ...mapGetters("project", [/* "isProjectLocked", */ "formatDate", "fetchRootCriteria", "readOnlyProject"]),
      
      baseFilteredProjectData() {
          return this.projectData.filter(
              proj => this.selectedProject === 0 || this.selectedProject == proj.project_id
          )
      },
      filteredSortedProjects() {
          let filtered = this.baseFilteredProjectData
          
              if (this.filters.title) {
                  filtered = filtered.filter(proj => 
                      proj.title.toLowerCase().includes(this.filters.title.toLowerCase())
                  )
              }
              
              if (this.filters.status) {
                  filtered = filtered.filter(proj => 
                      proj.status === this.filters.status
                  )
              }
              
              return [...filtered].sort((a, b) => {
                  switch (this.sortField) {
                      case "id":
                          return this.sortDirection === "asc" 
                              ? a.project_id - b.project_id
                              : b.project_id - a.project_id
                      case "title":
                          return this.sortDirection === "asc"
                              ? a.title.localeCompare(b.title)
                              : b.title.localeCompare(a.title)
                      case "status":
                          return this.sortDirection === "asc"
                              ? a.status.localeCompare(b.status)
                              : b.status.localeCompare(a.status)
                      case "creation_date":
                          return this.sortDirection === "asc"
                              ? new Date(a.creation_date) - new Date(b.creation_date)
                              : new Date(b.creation_date) - new Date(a.creation_date)
                      case "modification_date":
                          return this.sortDirection === "asc"
                              ? new Date(a.modification_date) - new Date(b.modification_date)
                              : new Date(b.modification_date) - new Date(a.modification_date)
                      default:
                          return a.project_id - b.project_id
                        }
                })
      },
      groupedProjects() {
        const projects = this.filteredSortedProjects
        if(projects.length === 0) {
            return []
        }
        const groups = {}

        projects.forEach(project => {
          if(!this.showArchived && project.status === 'ARCHIVE' && this.selectedProject == 0 ){
            // //console.log("skipping archived project in list view")
            return
          } else if((this.showArchived && project.status !== 'ARCHIVE' || !(project.PC || project.PE)) && this.selectedProject == 0){
            // //console.log("skipping non archived project in archived view because showArchived is true", this.showArchived)
            return
          }
          // //console.log("including project in list view", project)
          // if(project.status === 'ARCHIVE' && this.selectedProject == 0){
          //   // //console.log("skipping archived project in list view")
          //   return
          // }
          const refId = project.referential_id
          if(!groups[refId]){
            groups[refId]= {
              referential_id : refId,
              referential_title: project.referential_name || `Référentiel #${refId}`,
              projects: []
            }
          }
          groups[refId].projects.push(project)
        })
        return Object.values(groups)
      },
    },
    async mounted() {
      await this.$store.dispatch("project/fetchProjectList")
      if(this.$route.params.id != null && this.selectedProject > 0){
        await this.$store.dispatch("project/fetchProject", {payload : this.$route.params.id})
      }
      await this.$store.dispatch("project/fetchProjectList")
      this.$store.dispatch("referential/fetchReferentialList")
          .catch(error => console.error("Error fetching project data:", error))
        /* this.$store.dispatch("project/fetchAnswers", {id : this.$route.params.id}) */
      this.checkRouteParams()
    },
    watch: {
      '$route.params.id': 'checkRouteParams',
      //For updating value of the state (Seems the mutation isn't updating the state value)
    /*   answerQTest:{
        async handler(newVal){
          if(newVal){
            await this.$store.dispatch("project/fetchAllAnswers", { id: this.$route.params.id })
              return;
          }
        },
        deep:true,
        immediate:true,
      } */
    },
    methods: {
      async openPDF(project){
        if(!project)return;
        let selection = 1;
        if(project.status === "EDITING"){
          //console.log("selection = 1")
          selection = 0;
          }
        if(project.status === "VALIDATION"){
            selection = 1;
            //console.log("selection = 1")
        }
        if(project.status === "VALIDATED"){
            //console.log("selection = 2")
            selection = 2;
          }
          const payload = {
            id:this.selectedProject,
            type:selection
          }
          const pdfBlob = await this.$store.dispatch("project/createPDF", payload)
          //console.log("pdfBlob : ",pdfBlob)
          //const correctedImage = new Blob([pdfBlob]);
          //console.log("correctedImage ",correctedImage)
          if (pdfBlob && pdfBlob.size > 0) {
              const imageURL = URL.createObjectURL(pdfBlob);
              window.open(imageURL, '_blank_');
          } else {
              console.error("Failed to create PDF or received an empty blob.");
          }
      },
      async analyzeProject(){
        await this.$store.dispatch("project/projectValidate"),{
          id:this.selectedProject
        }
        let title = '';
        let message = '';
        const hasBlockingError = this.projectErrors.some(error => error.status === 'ERREUR');
        const hasErrors = this.projectErrors && this.projectErrors.length>0;
        title = 'Analyse du projet';
          if(hasErrors){
            message = "Le projet a des problèmes :<br><br>";
            for (const error of this.projectErrors){
                message += `<b>Status:</b> ${error.status}<br>`;
                message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                message += `<b>Message:</b> ${error.message}<br><br>`;
              }
            }else{
            message += `Aucun problème/info sur ce projet`;
          }
          this.$store.commit("project/returnConfirmationObjectMutation", { 
                id: this.selectedProject, 
                type: "project-analyze-status",
                title: title,
                message: message,
                hasBlockingError: hasBlockingError,
                //newStatus: status,
            })
      },
      getStatusLabel(status){
        if (!this.statusOptions) {
          return status
        }
        const optionValue = this.statusOptions.find(opt => opt.value === status)
        return optionValue ? optionValue.label : status
      },
      async checkRouteParams() {
          const routeId = this.$route.params.id
          //console.log("routeId : ",routeId)
          if (routeId) {
            try {
                const projectId = parseInt(routeId)
                const project = this.projectData.find(p => p.project_id === projectId)

                if (project) {
                    await this.$store.commit("project/selectProjectMutation", projectId)
                    if(projectId){
                      await this.$store.dispatch("project/fetchProjectCriteriaList", { id: projectId })
                      await this.$store.dispatch("project/fetchAllAnswers", { id: projectId })
                    }
                    await this.$store.dispatch("project/getProjectRights")
                } else {
                    console.error("Project not found in the existing list: ", projectId)
                }
            } catch (error) {
                console.error("Error in checkRouteParams: ", error)
            }
        } else {
            this.$store.commit("project/selectProjectMutation", 0)
        }
      },
      /* handleProjectClick(id) {
          if (this.loading) return

          if (this.selectedProject === id) {
              this.resetProject()
              this.$router.push('/project')
          } else {
              this.$router.push(`/project/${id}/generalData`)
          }
      }, */
      resetProject() {
          this.$store.commit("project/selectProjectMutation", 0)
          this.filters.title = ""
          this.filters.status = ""
          this.sortField = "id"
          this.sortDirection = "asc"
          this.$router.push('/project')
      },
      createProjectModalOpen() {
          if(this.selectedProject == 0) {
              this.$store.commit("referential/selectTreeMutation", 0)
              this.$store.commit("project/toggleProjectModalNew", true)
          } 
      },
      editProject() {
        //var project = this.projectData.find(p => p.project_id === this.selectedProject)
        //console.log("Editing project:", project)
        this.$store.commit("project/toggleProjectModalNew", true)
      },
      deleteProject(projectId) {
        //console.log(projectId)
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "delete-project",
              title: "Suppression",
              message: "Êtes-vous sûr de vouloir supprimer ce projet?"
          })
      },
      variantProject(projectId){
        if(this.selectedProject == 0) {
              this.$store.commit("project/selectProjectMutation", 0)
              this.$store.commit("project/toggleProjectModalNew", true)
          }
        this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "variant-project",
              title: "Variante",
              message: "Êtes-vous sûr de vouloir faire une variante de ce projet ?",
              create_variant: this.selectedProject,
              new_version: this.projectData.find(p => p.project_id === projectId).version,
          })
      },
      duplicateProject(projectId) {
        //console.log(projectId)
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: projectId, 
              type: "duplicate-project",
              title: "Duplication",
              message: "Êtes-vous sûr de vouloir dupliquer ce projet?"
          })
      },
      async changeProjectStatus(status) {
        await this.$store.dispatch("project/projectValidate", {
          id: this.selectedProject
        })
      let title = ""
      let message = ""
      //const hasBlockingError = this.projectErrors.some(error => error.status === 'ERREUR');
      const hasErrors = this.projectErrors && this.projectErrors.length > 0;

      if (hasErrors) {
              title = "Le projet a des problèmes :";
              for (const error of this.projectErrors) {
                      message += `<b>Status:</b> ${error.status}<br>`;
                      message += `<b class="parameters">Paramètre:</b> ${error.parameter}<br>`;
                      message += `<b>Message:</b> ${error.message}<br><br>`;
                  }
                  this.$store.commit("project/returnConfirmationObjectMutation", { 
                      id: this.selectedProject, 
                      type: "project-change-status",
                      title: title,
                      message: message,
                      newStatus: status,
                      //to bypass "fake" errors
                      //hasBlockingError: hasBlockingError,
                      status: this.releaseStatus,
                  })
                  return;
              } else {
              switch (status) {
              case "VALIDATION":
                  title = "Validation";
                  message = "Êtes-vous sûr de vouloir mettre ce projet en validation ?";
                  break;
              case "VALIDATED":
                  title = "Valider";
                  message = "Êtes-vous sûr de valider ce projet ?";
              break;
              case "ARCHIVE":
                  title = "Archiver"
                  message = "Êtes-vous sûr de vouloir archiver ce projet ?"
                  break;
              default:
                  title = "Remise en édition"
                  message = "Êtes-vous sûr de vouloir remettre ce projet en édition ?"
                  break;
          }
          this.$store.commit("project/returnConfirmationObjectMutation", { 
              id: this.selectedProject, 
              type: "project-change-status",
              title: title,
              message: message,
              //hasBlockingError: hasBlockingError,
              newStatus: status,
              status: this.releaseStatus
          })
      }
      //console.log("Changing referential status to : ", status)
      }    
  },
}

</script>
<style scoped>
/* grid */
.project-item{
  display: grid;
  grid-template-columns: 15% 35% 16% 17% 18%  ;
  /* grid-template-columns: 9% 39% 0% 21% 15% 16%; */
  width: 100%;
  align-items: center;
}

.project-item:has(.actions-col) {
    grid-template-columns: 25% 50% 25% ;
    background-color: none;
}

/* project list */
.project-list {
  /* border: 1px solid var(--border-color);
  background-color: #f8f9fa; */
  padding:8px;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.project-item {
  padding: 20px 14px;
  cursor: pointer;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  background-color: var(--bg-color) ;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.project-item:hover {
  /* transition: color 0.4s linear; */
  background-color: var(--hover-bg) ;
  border: 1.8px solid var(--border-color);
  border-left: 3.7px solid var(--primary-color);
  transition: all 0.11s ease-out ;
}

/* buttons */

.btn {
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.btn-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 18px;
  padding: 0;
  margin: 0 2px;
  background-color: var(--hover-bg);
  color: var(--text-color);
}

.btn-icon:hover {
  color: var(--primary-color);
}

.actions-col {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 3vw;
  gap: 2px;
}

.project-item.locked {
  opacity: 0.75;
}

.locked.locked{
  opacity: 1;
}

/* .referential-group-title {
  font-size: 1.5em;
  font-weight: bold;
  color: var(--primary-color);
  padding-bottom: 10px;
  border-bottom: 2px solid var(--primary-light);
  margin-bottom: 15px;
} */

.green-button{
  background-color: white;
  color: rgb(4, 185, 4);
  border: 1px solid rgb(4, 185, 4);
}
.green-button:hover{
  background-color: rgb(4, 185, 4);
  color: white;
}
.action-buttons{
  display: flex;
}
</style>